<template>
  <div>
    <div
      class="row shadow-sm"
      style="position: relative">
      <div class="bg-primary text-light p-4">
        <!-- Add Record -->
        <button
          v-if="view == 'index'"
          class="btn btn-primary float-end"
          style="position: absolute; right: 22px;top: 10px;"
          @click="setView('select')">
          <i class="fa fa-plus"/>
        </button>
        <div class="text-center">
          <h5>Display Tracking</h5>
        </div>
      </div>
    </div>
    <!-- Main Content -->
    <div class="container">
      <TmSelect v-if="view == 'tmSelect'"/>
      <Index v-if="view == 'index'"/>
      <CustomerSelect v-if="view == 'select'"/>
      <Detail v-if="view == 'detail'"/>
    </div>
  </div>
</template>

<script setup>
  import TmSelect from './views/tmSelect/TmSelect.vue';
  import Index from './views/Index/Index.vue';
  import CustomerSelect from './views/select/CustomerSelect.vue';
  import Detail from './views/detail/Detail.vue';
  import { computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';
  import { managerRoles } from '../../../../../shared/roles';

  // Initialize
  const store = useStore()

  // Data
  const selectedTm = ref(null)

  // LifeCycle
  onMounted(()=>{
    const manager = managerRoles.includes(store.getters.user.role)
    const activeTm = store.getters.activeTm
    const startView = manager && !activeTm ? 'tmSelect' : 'index'
    store.dispatch('displayTrackingSetView', startView)
    store.dispatch('displayTrackingGetItems')
  })

  // Methods
  const setView = (view)=>{
    store.dispatch('displayTrackingSetView', view)
  }

  // Computed
  const view = computed(()=>{
    return store.getters.displayTrackingView
  })
</script>